import { z } from "zod";

// Paridade com dc-not-empty do legado: dataInteracao e descricao são
// obrigatórios (tipoInteracao não tem a diretiva, mas o select nunca tem
// opção vazia — tratado como enum obrigatório também; usuarioContato não
// tem validação). Instituição (obrigatória) e Tela (opcional) ficam FORA
// deste schema — são objetos de lookup geridos em estado à parte no
// componente (mesmo padrão das roles em LayoutNotificacao), não campos de
// texto simples que o RHF valide diretamente.
export const interacaoSchema = z.object({
  id: z.number().optional(),
  dataInteracao: z.string().min(1, "Informe a data de interação."),
  tipoInteracao: z.enum(["SU", "CB", "CN", "TR", "CA", "SA"]),
  usuarioContato: z.string().optional(),
  descricao: z.string().min(1, "Informe a descrição."),
});

export type InteracaoFormValues = z.infer<typeof interacaoSchema>;
